module.exports = false;


//////////////////
// WEBPACK FOOTER
// ../documittu/packages/template/~/core-js/modules/_library.js
// module id = 67
// module chunks = 0